import { Link } from "react-router-dom";
import { useSiteNav } from "./Navbar";

const MODI_LOGO =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_15aa463c-f5dd-46c0-8049-efe882557866/artifacts/2ks7hjk8_Modi%20Auto%20Group%20%28Black%29.png";

export default function Footer() {
  const goTo = useSiteNav();
  return (
    <footer className="border-t border-navy-ink/10 bg-navy px-6 py-16 lg:px-12" data-testid="footer">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col justify-between gap-12 lg:flex-row lg:items-start">
          <div>
            <img src="/modi-marine-logo.png" alt="Modi Marine" className="h-7 w-auto" data-testid="footer-brand" />
            <p className="mt-4 max-w-xs text-xs font-light leading-relaxed text-mist" data-testid="footer-tagline">
              Super-premium yacht distribution for India&rsquo;s most discerning
              mariners, with a pan-India presence.
            </p>
          </div>

          <nav className="flex flex-col gap-3" data-testid="footer-nav">
            {[
              ["Legacy", "#legacy", "footer-link-legacy"],
              ["New Yachts", "/yachts", "footer-link-yachts"],
              ["Brand Partners", "#brands", "footer-link-brands"],
              ["After Sales", "#after-sales", "footer-link-after-sales"],
              ["Contact", "#contact", "footer-link-contact"],
            ].map(([label, href, id]) => (
              <a
                key={href}
                href={href}
                onClick={(e) => { e.preventDefault(); goTo(href); }}
                data-testid={id}
                className="text-[11px] uppercase tracking-[0.28em] text-mist transition-colors duration-300 hover:text-gold"
              >
                {label}
              </a>
            ))}
          </nav>

          <div className="flex flex-col items-start gap-4 border border-navy-ink/10 bg-navy-light/40 px-8 py-6">
            <span className="text-[9px] uppercase tracking-[0.35em] text-mist">A unit of</span>
            <img src={MODI_LOGO} alt="Modi Auto Group" className="h-10 w-auto" data-testid="footer-modi-logo" />
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-4 border-t border-navy-ink/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-[10px] uppercase tracking-[0.25em] text-mist/60" data-testid="footer-copyright">
            &copy; 2026 Modi Marine. All rights reserved.
          </p>
          <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="footer-legal-nav">
            <Link to="/privacy-policy" data-testid="footer-link-privacy" className="text-[10px] uppercase tracking-[0.25em] text-mist/70 transition-colors duration-300 hover:text-gold">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="text-[10px] uppercase tracking-[0.25em] text-mist/70 transition-colors duration-300 hover:text-gold">Terms &amp; Conditions</Link>
          </nav>
          <p className="text-[10px] uppercase tracking-[0.25em] text-mist/60" data-testid="footer-motto">
            Craft · Heritage · Horizon
          </p>
        </div>
      </div>
    </footer>
  );
}
